export const PAGE_BANNER_BG = 'linear-gradient(90deg, #3F66BB 0%, #34A1FB 100%)';

export const PAGE_BANNER_CARD_SX = {
  mb: { xs: 3, sm: 4 },
  minHeight: 'auto',
  display: 'flex',
  flexDirection: 'column',
  background: PAGE_BANNER_BG,
  color: '#fff',
  borderRadius: '16px',
  boxShadow: '0 10px 15px -3px rgba(15, 23, 42, 0.2), 0 4px 6px -4px rgba(15, 23, 42, 0.1)',
  position: 'relative',
  overflow: 'hidden',
};

export const PAGE_BANNER_DECORATION_SX = {
  position: 'absolute',
  top: '-50%',
  left: '-10%',
  width: '50%',
  height: '200%',
  background: 'radial-gradient(circle, rgba(99,102,241,0.15) 0%, rgba(0,0,0,0) 70%)',
  transform: 'rotate(30deg)',
  pointerEvents: 'none',
};

export const PAGE_BANNER_CONTENT_SX = {
  py: { xs: '20px !important', sm: '32px !important' },
  px: { xs: '16px !important', sm: '32px !important' },
  position: 'relative',
  zIndex: 1,
};

export const PAGE_BANNER_INNER_SX = {
  display: 'flex',
  flexDirection: { xs: 'column', sm: 'row' },
  justifyContent: 'space-between',
  alignItems: { xs: 'flex-start', sm: 'center' },
  gap: 2,
};

export const PAGE_BANNER_HEADING_SX = {
  fontSize: { xs: '20px', sm: '28px' },
  fontWeight: 700,
  color: '#fff',
  letterSpacing: '0.5px',
  lineHeight: 1.2,
  mb: 0.5,
};

export const PAGE_BANNER_SUBHEADING_SX = {
  color: 'rgba(255,255,255,0.8)',
  fontWeight: 400,
  fontSize: { xs: '13px', sm: '14px' },
};

export const PAGE_BANNER_PRIMARY_BTN_SX = {
  height: 40,
  px: { xs: 1.25, sm: 2.5 },
  whiteSpace: 'nowrap',
  fontSize: { xs: '0.8rem', sm: '0.875rem' },
  borderRadius: 1.5,
  fontWeight: 600,
  bgcolor: '#FFFFFF',
  color: '#3F66BB',
  boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
  '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.9)', boxShadow: '0 4px 8px rgba(0,0,0,0.12)' },
  '&.Mui-disabled': {
    bgcolor: 'rgba(255, 255, 255, 0.2)',
    color: 'rgba(255, 255, 255, 0.5)',
  },
};

export const PAGE_BANNER_OUTLINED_BTN_SX = {
  height: 40,
  px: { xs: 1.25, sm: 2.5 },
  whiteSpace: 'nowrap',
  fontSize: { xs: '0.8rem', sm: '0.875rem' },
  borderRadius: 1.5,
  fontWeight: 600,
  color: '#FFFFFF',
  borderColor: 'rgba(255, 255, 255, 0.3)',
  bgcolor: 'rgba(255, 255, 255, 0.08)',
  '&:hover': { borderColor: '#FFFFFF', bgcolor: 'rgba(255, 255, 255, 0.15)' },
  '&.Mui-disabled': {
    color: 'rgba(255, 255, 255, 0.4)',
    borderColor: 'rgba(255, 255, 255, 0.15)',
    bgcolor: 'rgba(255, 255, 255, 0.04)',
  },
};
